import { combineReducers } from '@reduxjs/toolkit';
import { RootState } from 'modules/store';
import avsConfiguration from 'modules/avs/configuration/avsConfiguration.slice';
import avsIbanVerification from 'modules/avs/ibanVerification/avsIbanVerification.slice';
import avsInternationalVerification from 'modules/avs/internationalVerification/avsInternationalVerification.slice';

// Combined reducer
const avs = combineReducers({
  configuration: avsConfiguration,
  ibanVerification: avsIbanVerification,
  internationalVerification: avsInternationalVerification,
});

export default avs;

// Selectors
export const selectAvsConfigurationState = (state: RootState) =>
  state.root.avs.configuration;
export const selectAvsIbanVerificationState = (state: RootState) =>
  state.root.avs.ibanVerification;
export const selectAvsInternationalVerificationState = (state: RootState) =>
  state.root.avs.internationalVerification;

// Backward-compatible selector that combines all state
export const selectAvsState = (state: RootState) => ({
  ...state.root.avs.configuration,
  ...state.root.avs.ibanVerification,
  ...state.root.avs.internationalVerification,
});

// Export types
export * from 'modules/avs/avs.types';

// Export actions from configuration
export {
  getAvsConfigurations,
  updateAvsConfigurations,
  requestServiceAccess,
} from 'modules/avs/configuration/avsConfiguration.actions';
export { setUpdateConfigurations } from 'modules/avs/configuration/avsConfiguration.slice';

// Export actions from IBAN verification
export {
  verifyAccount,
  uploadBulkVerification,
  getVerificationRecords,
  getBulkVerificationResult,
  getBulkVerificationResultData,
  getIbanVerificationResult,
} from 'modules/avs/ibanVerification/avsIbanVerification.actions';
export { resetVerificationState } from 'modules/avs/ibanVerification/avsIbanVerification.slice';

// Export actions from international verification
export {
  uploadInternationalBulkVerification,
  getInternationalVerificationRecords,
  getInternationalBulkVerificationResult,
  getInternationalBulkVerificationResultData,
  getInternationalVerificationResult,
} from 'modules/avs/internationalVerification/avsInternationalVerification.actions';

// Export sample CSV files
export * from 'modules/avs/avs.sampleCsvFile';
export * from 'modules/avs/avs.internationalSampleCsvFile';